import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, type GridProps } from '@mui/material'

import type {
  InventoryOrder,
  InventoryOrderItem,
} from '~/api/graphql/generated/types'
import { LabelValue } from '~/components/common/labels/LabelValue'
import Typography from '~/components/elements/Typography/Typography'

import ShipmentItemStatusLabel from '../../shipments/ShipmentItemStatusLabel'
import { OrderItemFlags } from '../order-items/OrderItemFlags'
import { OrderCard } from '../OrderCard'

interface OrderItemReceiptsPageHeaderProps extends GridProps {
  inventoryOrder: InventoryOrder
  inventoryOrderItem: InventoryOrderItem
}

export const OrderItemReceiptsPageHeader = ({
  inventoryOrder,
  inventoryOrderItem,
}: OrderItemReceiptsPageHeaderProps) => {
  const { t } = useTranslation()

  return (
    <Box display="flex" flexDirection="column" gap={0.5}>
      <OrderCard inventoryOrder={inventoryOrder} />
      <Box alignItems="center" display="flex" gap={1} mt={4}>
        <Typography.H1 color="brandPrimary">
          {t('Admin:CATALOG.ORDERS.RECEIVE_ITEM_TITLE', {
            itemName: inventoryOrderItem.inventoryItem.variation?.composedName,
          })}
        </Typography.H1>
        <ShipmentItemStatusLabel statusId={inventoryOrderItem.status.id} />
      </Box>
      <OrderItemFlags
        controlled={inventoryOrderItem.inventoryItem.controlled}
        // @ts-expect-error - storeCold is not a property of BusinessCatalogItem yet
        storeCold={inventoryOrderItem.inventoryItem.storeCold}
      />
      <Box alignItems="center" display="flex" gap={2}>
        <LabelValue
          label={t('Admin:CATALOG.ORDERS.INTERNAL_PART_NUMBER_LABEL')}
          value={inventoryOrderItem.inventoryItem.variation?.cumulusId || '-'}
        />
        <LabelValue
          label={t('Admin:CATALOG.ORDERS.SUPPLIER_SKU_LABEL')}
          value={inventoryOrderItem.sku}
        />
        <LabelValue
          label={t('Admin:CATALOG.ORDERS.QUANTITY_ORDERED_LABEL')}
          value={inventoryOrderItem.orderedQuantity}
        />
      </Box>
    </Box>
  )
}
